<template lang="pug">
    v-container( class=" pa-0   " )
        v-row(class="tw-border-gray-200 tw-bg-gray-100 tw-border-solid tw-border my-1 pa-0 mx-2" )
            v-col(class="pa-0 ma-0 " sm=12 md=12 lg=3 )
               v-img( :src="goods.image" class="pa-0 ma-0" )
            v-col( sm=12 md=12 lg=9 class=" lg:tw-w-2/4 py-1 " )
                v-row
                    v-col(class=" py-0 tw-font-bold tw-text-gray-700 tw-text-sm")
                        |{{ goods.address }}
                v-row
                    v-col(class=" py-0 tw-text-sm")
                        |{{ goods.bedrooms}} Beds {{ goods.bathrooms }} Baths
</template>
<script>
    export default {
        props: {
            goods: {
                type: Object,
                default: null,
            },
        },
    };
</script>
